import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ArticleViewPage from './pages/ArticleViewPage';
import ToolBioPage from './pages/ToolBioPage';
import DisclosurePage from './pages/DisclosurePage';
import ComparePage from './pages/ComparePage';
import AboutPage from './pages/AboutPage';
import FlowPage from './pages/FlowPage';

const App: React.FC = () => {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tool-finder" element={<Navigate to="/" replace />} />
        <Route path="/articles" element={<Navigate to="/" replace />} />
        <Route path="/articles/:slug" element={<ArticleViewPage />} />
        <Route path="/tools/:slug" element={<ToolBioPage />} />
        <Route path="/disclosure" element={<DisclosurePage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/compare/:slugA/:slugB" element={<ComparePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/flows/:slug" element={<FlowPage />} />
      </Routes>
    </Layout>
  );
};

export default App;